const headerImages = {
  HEADER_IMAGE_WITH_LOGO: require("./header-image-with-logo.png"),
};
export { headerImages };
